export const footer_i18n = {
    text1: "Prywatność",
    text2: "Regulamin",
    text3: "Mapa witryny"
};